export const UserLevels = {
    SUBORGUNIT: 0,
    ORGUNIT: 1,
    TENANT: 2,
    ROOT: 3
};